class KeyboardController {
  constructor(storage,$state, $scope, $rootScope, navigationManager, billingService, analyticsService) {
    this.name = 'Go Paperless';
    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.analyticsService = analyticsService;
    this.focusChange = {};
    this.special_characters = false;
    this.keynavigation = [
      {text: '', key: 'del', left: '', up: '', down: 'a', right: 'inText'},
      {text: '', key: 'inText', left: 'del', up: '', down: 'b', right: 'outText'},
      {text: '', key: 'outText', left: 'inText', up: '', down: 'c', right: 'clear'},
      {text: '', key: 'clear', left: 'outText', up: '', down: 'd', right: 'special_characters'},
      {text: '', key: 'special_characters', left: 'clear', up: '', down: 'e', right: 'optemail', next: 'regular_characters'},

      {text: '@optimum.net', key: 'optemail', left: 'clear', up: '', down: 'gmailemail', right: ''},
      {text: '@gmail.com', key: 'gmailemail', left: '3', up: 'optemail', down: 'yahooemail', right: ''},
      {text: '@yahoo.com', key: 'yahooemail', left: '6', up: 'gmailemail', down: 'aolemail', right: ''},
      {text: '@aol.com', key: 'aolemail', left: '9', up: 'yahooemail', down: 'hotmailemail', right: ''},
      {text: '@hotmail.com', key: 'hotmailemail', left: '0', up: 'aolemail', down: 'btnEnroll', right: ''},

      {text: '', key: 'btnEnroll', left: 'btnCancel', up: 'atThe', down: '', right: ''},
      {text: '', key: 'btnCancel', left: '', up: 'atThe', down: '', right: 'btnEnroll'},

      {text: '', key: 'btnConfirm', left: 'btnBack', up: '', down: '', right: ''},
      {text: '', key: 'btnBack', left: '', up: '', down: '', right: 'btnConfirm'},
      {text: '', key: 'btnOK', left: '', up: '', down: '', right: ''},

      {text: 'a', key: 'a', left: '', up: 'del', down: 'j', right: 'b'},
      {text: 'b', key: 'b', left: 'a', up: 'inText', down: 'k', right: 'c'},
      {text: 'c', key: 'c', left: 'b', up: 'outText', down: 'l', right: 'd'},
      {text: 'd', key: 'd', left: 'c', up: 'clear', down: 'm', right: 'e'},
      {text: 'e', key: 'e', left: 'd', up: 'special_characters', down: 'n', right: 'f'},
      {text: 'f', key: 'f', left: 'e', up: 'special_characters', down: 'o', right: 'g'},
      {text: 'g', key: 'g', left: 'f', up: 'special_characters', down: 'p', right: 'h'},
      {text: 'h', key: 'h', left: 'g', up: 'special_characters', down: 'q', right: 'i'},
      {text: 'i', key: 'i', left: 'h', up: 'special_characters', down: 'r', right: '1'},
      {text: 'j', key: 'j', left: '', up: 'a', down: 's', right: 'k'},
      {text: 'k', key: 'k', left: 'j', up: 'b', down: 't', right: 'l'},
      {text: 'l', key: 'l', left: 'k', up: 'c', down: 'u', right: 'm'},
      {text: 'm', key: 'm', left: 'l', up: 'd', down: 'v', right: 'n'},
      {text: 'n', key: 'n', left: 'm', up: 'e', down: 'w', right: 'o'},
      {text: 'o', key: 'o', left: 'n', up: 'f', down: 'x', right: 'p'},
      {text: 'p', key: 'p', left: 'o', up: 'g', down: 'y', right: 'q'},
      {text: 'q', key: 'q', left: 'p', up: 'h', down: 'z', right: 'r'},
      {text: 'r', key: 'r', left: 'q', up: 'i', down: 'z', right: '4'},
      {text: 's', key: 's', left: '', up: 'j', down: 'atThe', right: 't'},
      {text: 't', key: 't', left: 's', up: 'k', down: 'dot', right: 'u'},
      {text: 'u', key: 'u', left: 't', up: 'l', down: 'dash', right: 'v'},
      {text: 'v', key: 'v', left: 'u', up: 'm', down: 'underscore', right: 'w'},
      {text: 'w', key: 'w', left: 'v', up: 'n', down: 'underscore', right: 'x'},
      {text: 'x', key: 'x', left: 'w', up: 'o', down: 'underscore', right: 'y'},
      {text: 'y', key: 'y', left: 'x', up: 'p', down: 'underscore', right: 'z'},
      {text: 'z', key: 'z', left: 'y', up: 'q', down: 'underscore', right: '7'},

      // special character keys starts here

      {text: '@optimum.net', key: 'optemail_special', left: 'regular_characters', up: '', down: 'gmailemail_special', right: ''},
      {text: '@gmail.com', key: 'gmailemail_special', left: '3_special', up: 'optemail_special', down: 'yahooemail_special', right: ''},
      {text: '@yahoo.com', key: 'yahooemail_special', left: '6_special', up: 'gmailemail_special', down: 'aolemail_special', right: ''},
      {text: '@aol.com', key: 'aolemail_special', left: '9_special', up: 'yahooemail_special', down: 'hotmailemail_special', right: ''},
      {text: '@hotmail.com', key: 'hotmailemail_special', left: '0_special', up: 'aolemail_special', down: 'btnEnroll_special', right: ''},

      {text: '', key: 'del_special', left: '', up: '', down: '%', right: 'inText_special'},
      {text: '', key: 'inText_special', left: 'del_special', up: '', down: '|', right: 'outText_special'},
      {text: '', key: 'outText_special', left: 'inText_special', up: '', down: '#', right: 'clear_special'},
      {text: '', key: 'clear_special', left: 'outText_special', up: '', down: '&', right: 'regular_characters'},
      {text: '', key: 'regular_characters', left: 'clear_special', up: '', down: '@', right: 'optemail_special', next: 'special_characters'},

      {text: '%', key: '%', left: '', up: 'del_special', down: '`', right: '|'},
      {text: '|', key: '|', left: '%', up: 'inText_special', down: '"', right: '#'},
      {text: '#', key: '#', left: '|', up: 'outText_special', down: "'", right: '&'},
      {text: '&', key: '&', left: '#', up: 'clear_special', down: ';', right: '@'},
      {text: '@', key: '@', left: '&', up: 'regular_characters', down: ':', right: '!'},
      {text: '!', key: '!', left: '@', up: 'regular_characters', down: '?', right: '^'},
      {text: '^', key: '^', left: '!', up: 'regular_characters', down: '>', right: '1_special'},

      {text: '`', key: '`', left: '', up: '%', down: '=', right: '"'},
      {text: '"', key: '"', left: '`', up: '|', down: '*', right: "'"},
      {text: "'", key: "'", left: '"', up: '#', down: '+', right: ';'},
      {text: ';', key: ';', left: "'", up: '&', down: '_', right: ':'},
      {text: ':', key: ':', left: ';', up: '@', down: '-', right: '?'},
      {text: '?', key: '?', left: ':', up: '!', down: ',', right: '>'},
      {text: '>', key: '>', left: '?', up: '^', down: "<", right: '$'},
      {text: '$', key: '$', left: '>', up: '^', down: '~', right: '4_special'},

      {text: '=', key: '=', left: '', up: '`', down: '[', right: '*'},
      {text: '*', key: '*', left: '=', up: '"', down: ']', right: '+'},
      {text: '+', key: '+', left: '*', up: "'", down: '{', right: '_'},
      {text: '_', key: '_', left: '+', up: ';', down: '}', right: '-'},
      {text: '-', key: '-', left: '_', up: ':', down: '(', right: ','},
      {text: ',', key: ',', left: '-', up: '?', down: ')', right: '<'},
      {text: "<", key: "<", left: ',', up: '>', down: '\\', right: '~'},
      {text: '~', key: '~', left: "<", up: '$', down: '/', right: '7_special'},

      {text: '[', key: '[', left: '', up: '=', down: 'btnEnroll_special', right: ']'},
      {text: ']', key: ']', left: '[', up: '*', down: 'btnEnroll_special', right: '{'},
      {text: '{', key: '{', left: ']', up: '+', down: 'btnEnroll_special', right: '}'},
      {text: '}', key: '}', left: '{', up: '_', down: 'btnEnroll_special', right: '('},
      {text: '(', key: '(', left: '}', up: '-', down: 'btnEnroll_special', right: ')'},
      {text: ')', key: ')', left: '(', up: ',', down: 'btnEnroll_special', right: '\\'},
      {text: '\\', key: '\\', left: ')', up: "<", down: 'btnEnroll_special', right: '/'},
      {text: '/', key: '/', left: '\\', up: '~', down: 'btnEnroll_special', right: '0_special'},

      {text: '1', key: '1_special', left: '^', up: 'regular_characters', down: '4_special', right: '2_special'},
      {text: '2', key: '2_special', left: '1_special', up: 'regular_characters', down: '5_special', right: '3_special'},
      {text: '3', key: '3_special', left: '2_special', up: 'regular_characters', down: '6_special', right: 'gmailemail_special'},
      {text: '4', key: '4_special', left: '$', up: '1_special', down: '7_special', right: '5_special'},
      {text: '5', key: '5_special', left: '4_special', up: '2_special', down: '8_special', right: '6_special'},
      {text: '6', key: '6_special', left: '5_special', up: '3_special', down: '9_special', right: 'yahooemail_special'},
      {text: '7', key: '7_special', left: '~', up: '4_special', down: '0_special', right: '8_special'},
      {text: '8', key: '8_special', left: '7_special', up: '5_special', down: '0_special', right: '9_special'},
      {text: '9', key: '9_special', left: '8_special', up: '6_special', down: '0_special', right: 'aolemail_special'},
      {text: '0', key: '0_special', left: '/', up: '8_special', down: 'btnEnroll_special', right: 'hotmailemail_special'},

      {text: '', key: 'btnEnroll_special', left: 'btnCancel_special', up: '[', down: '', right: ''},
      {text: '', key: 'btnCancel_special', left: '', up: '[', down: '', right: 'btnEnroll_special'},



      {text: '1', key: '1', left: 'i', up: 'clear', down: '4', right: '2'},
      {text: '2', key: '2', left: '1', up: 'clear', down: '5', right: '3'},
      {text: '3', key: '3', left: '2', up: 'clear', down: '6', right: 'gmailemail'},
      {text: '4', key: '4', left: 'r', up: '1', down: '7', right: '5'},
      {text: '5', key: '5', left: '4', up: '2', down: '8', right: '6'},
      {text: '6', key: '6', left: '5', up: '3', down: '9', right: 'yahooemail'},
      {text: '7', key: '7', left: 'z', up: '4', down: '0', right: '8'},
      {text: '8', key: '8', left: '7', up: '5', down: '0', right: '9'},
      {text: '9', key: '9', left: '8', up: '6', down: '0', right: 'aolemail'},
      {text: '0', key: '0', left: 'underscore', up: '8', down: 'btnEnroll', right: 'hotmailemail'},

      {text: '@', key: 'atThe', left: '', up: 's', down: 'btnEnroll', right: 'dot'},
      {text: '.', key: 'dot', left: 'atThe', up: 't', down: 'btnEnroll', right: 'dash'},
      {text: '-', key: 'dash', left: 'dot', up: 'u', down: 'btnEnroll', right: 'underscore'},
      {text: '_', key: 'underscore', left: 'dash', up: 'v', down: 'btnEnroll', right: '0'}
    ];
    this.showEmailError = false;
    this.cursorCnt = 0;
    this.subStringOne = '';
    this.subStringTwo = '';
    this.displayModal = false;
    this.displayModalContent = false;
    this.loading = false;

    navigationManager.registerViewComponent(this, $scope, 'home.keyboard');
    //omniture when Enroll update email keyboard
    console.log('!!omniture when Enroll update email keyboard');
    this.analyticsService.sendReport('go paperless', 'email keyboard', 'event1', null, null, null, null, null, this.$rootScope.omnitureBillingStatus, $scope.omniturePaperlessbill);

    this.getKeyNavigation = (itemId) => {
      return this.keynavigation.filter(function (item) {
        return (item.key === itemId);
      });
    };

    this.textChange = (value) => {
      var regEx = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,3})$/;
      var result = regEx.test(value);
      return !result;
    };

    this.enteredEmail = storage.getItem('session', 'userEmail') || '';
    //this.enteredEmail = 'bhavindesai20@gmail.com';
    this.startIndex = (this.enteredEmail) ? ((this.enteredEmail).length) : 0;
    this.subStringOne = this.enteredEmail;
    this.doSelect(this.startIndex, this.startIndex);
    if(this.enteredEmail === ''){
      this.currentItem = this.getKeyNavigation('a');
      this.addFocusClass('a');
    } else{
      this.currentItem = this.getKeyNavigation('del');
      this.addFocusClass('del');
    }

    this.keyWatch = event => {
      const eventTarget = document.getElementById('keyBoardContainer');
      eventTarget.addEventListener('keydown', this.keydown);
      eventTarget.addEventListener('keyup', this.keyup);
    };

    this.keyup = () => {
      //console.log({"subStringOne":this.subStringOne,"subStringTwo":this.subStringTwo,
      //  "enteredEmail":this.enteredEmail,"startIndex":this.startIndex,"cursorCnt":this.cursorCnt});
    };

    this.keydown = (event)=> {
      var navItem = this.currentItem[0];
      this.eventPropFocus(event);
      if(event.keyCode === 27 || event.keyCode ===8 || event.keyCode ===461){
          this.eventPropFocus(event);
          if(!this.displayAlertModal && !this.displayModal){
            document.getElementById('keyBoardContainer').removeEventListener('keydown', this.keydown);
            this.$state.go('home.paperlessbilling');
          } else {
            console.log("Back button should not work here");
          }
      }
      else if (event.keyCode === 13) {
        if (navItem.key === 'btnCancel' || navItem.key === 'btnCancel_special') {
          this.eventPropFocus(event);
          document.getElementById('keyBoardContainer').removeEventListener('keydown', this.keydown);
          this.$state.go('home.paperlessbilling');
        }
        else if (navItem.key === 'btnEnroll' || navItem.key === 'btnEnroll_special') {
          //omniture when Enroll update email keyboard button select
          console.log('!!omniture when Enroll update email keyboard button select');
          this.analyticsService.sendReport('go paperless', 'email keyboard', null, null, null, null, 'Enroll', 
            this.$rootScope.analytics.omniturePath +'/paperlessbilling', this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill);

          if(this.enteredEmail){
            this.$scope.$apply(()=> {
              this.showEmailError = this.textChange(this.enteredEmail);
              if(!this.showEmailError){
                this.displayModal = true;
                //omniture when Enroll update email keyboard confirmation popup
                console.log('!!omniture when Enroll update email keyboard confirmation popup');
                this.analyticsService.sendReport('go paperless', 'email keyboard review', 'event1', null, null, null, null, null, 
                  this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill);

                this.displayModalContent = true;
                this.removeFocusClass(navItem.key);
                if (this.special_characters = false){
                  this.currentItem = this.getKeyNavigation('btnConfirm_special');
                } else {
                  this.currentItem = this.getKeyNavigation('btnConfirm');
                }
                this.addFocusClass(this.currentItem[0].key);
                this.eventPropFocus(event);
              } else {
                //omniture when email keyboard error
                console.log('!!omniture when email keyboard error');
                this.analyticsService.sendReport('go paperless', 'email keyboard error', null, 'invalid email error', null, null, null, null, 
                  this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill);
              }
            });
          }
          else{
            this.$scope.$apply(()=> {
              this.showEmailError = this.textChange(this.enteredEmail);
            });
          }
        }
        else if(navItem.key === 'btnBack'){
          console.log("i am coming here in keycode 13");
          this.$scope.$apply(()=> {
            this.displayModal = false;
            this.displayModalContent = false;
            this.removeFocusClass(navItem.key);
            this.currentItem = this.getKeyNavigation('btnEnroll');
            this.addFocusClass(this.currentItem[0].key);
            this.addFocusClass('btnEnroll');
            this.eventPropFocus(event);
          });
        }
        else if(navItem.key === 'btnBack_special'){
          console.log("i am coming here in keycode 13");
          this.$scope.$apply(()=> {
            this.displayModal = false;
            this.displayModalContent = false;
            this.removeFocusClass(navItem.key);
            this.currentItem = this.getKeyNavigation('btnEnroll_special');
            this.addFocusClass(this.currentItem[0].key);
            this.addFocusClass('btnEnroll');
            this.eventPropFocus(event);
          });
        }
        else if(navItem.key === 'btnConfirm' || navItem.key === 'btnConfirm_special'){
          console.log("i am coming here in keycode 13");
          //omniture when Enroll update email keyboard confirmation popup button select
          console.log('!!omniture when Enroll update email keyboard confirmation popup button select');
          this.analyticsService.sendReport('go paperless', 'email keyboard review', null, null, null, null, 'confirm', 
            this.$rootScope.analytics.omniturePath +'/landingpage/paperlessbillinglanding', this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill);
          this.$scope.$apply(()=> {
            this.removeFocusClass(navItem.key);
            this.displayModalContent=false;
            this.loading = true;
            var emailVal = this.enteredEmail;
            billingService.enrollPaperlessBill(false, emailVal).then(res => {
              console.log("Result in enroll api:", res);
              if(res.data.responseInfo !== null  && res.data.responseInfo.statusCode === "00000"){
                this.loading=false;
                this.$rootScope.enrollValue = true;

                //omniture paperless enrollment success
                console.log('!!omniture paperless enrollment success');
                this.$rootScope.paperlessbilling = true;
                this.analyticsService.sendReport('go paperless', 'paperless enrollment success', 'event7', null, null, null, null, null,
                  this.$rootScope.omnitureBillingStatus, true, this.$rootScope.analytics.omniturePath +'/landingpage');

                this.eventPropFocus(event);
                document.getElementById('keyBoardContainer').removeEventListener('keydown', this.keydown);
                this.$rootScope.fromPaperlessBillingPage = true;
                this.$state.go('home.landingpage', {}, { reload: true });
              } else {
                this.loading=false;
                this.displayModal = false;
                this.displayAlertModal = true;
                this.currentItem = this.getKeyNavigation('btnOK');
                this.addFocusClass(this.currentItem[0].key);
                this.eventPropFocus(event);
              }
            });
          });
        }
        else if(navItem.key === 'btnOK'){
            console.log("i am coming here in keycode 13 of button OK");
            this.$scope.$apply(()=> {
              this.displayAlertModal = false;
              this.removeFocusClass(navItem.key);
              this.currentItem = this.getKeyNavigation('btnEnroll');
              this.addFocusClass(this.currentItem[0].key);
              this.addFocusClass('btnEnroll');
              this.eventPropFocus(event);
            });
        }
        else if (navItem.key === 'del') {
          //if something available to delete
          if(this.subStringOne){
            this.$scope.$apply(()=>{
              this.subStringOne = (this.subStringOne).slice(0, -1);
              this.enteredEmail = this.subStringOne + (this.subStringTwo);
              this.startIndex = this.startIndex != 0 ? this.startIndex - 1 : 0;
              this.showEmailError = false;
            });
            this.doSelect(this.subStringOne.length, this.subStringOne.length);
          }
        }
        else if (navItem.key === 'del_special') {
          //if something available to delete
          if(this.subStringOne){
            this.$scope.$apply(()=>{
              this.subStringOne = (this.subStringOne).slice(0, -1);
              this.enteredEmail = this.subStringOne + (this.subStringTwo);
              this.startIndex = this.startIndex != 0 ? this.startIndex - 1 : 0;
              this.showEmailError = false;
            });
            this.doSelect(this.subStringOne.length, this.subStringOne.length);
          }
        }
        else if (navItem.key === 'inText') {
          if (this.enteredEmail && ((this.enteredEmail).length)!=this.cursorCnt) {
            this.showEmailError = false;
            this.cursorCnt = this.cursorCnt + 1;
            this.startIndex = this.startIndex - 1;
            this.subStringOne = (this.enteredEmail).substr(0,this.startIndex);
            this.subStringTwo = (this.enteredEmail).substr(this.startIndex);
            console.log(this.subStringOne +' String change ' + this.subStringTwo);
            this.doSelect(this.startIndex, this.startIndex);
          }
        }
        else if (navItem.key === 'inText_special') {
          if (this.enteredEmail && ((this.enteredEmail).length)!=this.cursorCnt) {
            this.showEmailError = false;
            this.cursorCnt = this.cursorCnt + 1;
            this.startIndex = this.startIndex - 1;
            this.subStringOne = (this.enteredEmail).substr(0,this.startIndex);
            this.subStringTwo = (this.enteredEmail).substr(this.startIndex);
            console.log(this.subStringOne +' String change ' + this.subStringTwo);
            this.doSelect(this.startIndex, this.startIndex);
          }
        }
        else if (navItem.key === 'outText') {
          if (this.enteredEmail && this.cursorCnt >= 0) {
            this.showEmailError = false;
            this.cursorCnt = this.cursorCnt != 0 ? this.cursorCnt - 1 : 0;
            this.startIndex = this.startIndex + 1;
            this.subStringOne = (this.enteredEmail).substr(0,this.startIndex);
            this.subStringTwo = (this.enteredEmail).substr(this.startIndex);
            console.log(this.subStringOne +' String change ' + this.subStringTwo);
            this.doSelect(this.startIndex, this.startIndex);
          }
        }
        else if (navItem.key === 'outText_special') {
          if (this.enteredEmail && this.cursorCnt >= 0) {
            this.showEmailError = false;
            this.cursorCnt = this.cursorCnt != 0 ? this.cursorCnt - 1 : 0;
            this.startIndex = this.startIndex + 1;
            this.subStringOne = (this.enteredEmail).substr(0,this.startIndex);
            this.subStringTwo = (this.enteredEmail).substr(this.startIndex);
            console.log(this.subStringOne +' String change ' + this.subStringTwo);
            this.doSelect(this.startIndex, this.startIndex);
          }
        }
        else if (navItem.key === 'clear') {
            this.$scope.$apply(()=>{
              this.enteredEmail = '';
              this.subStringOne = '';
              this.subStringTwo = '';
              this.startIndex = 0;
              //this.showEmailError =  this.textChange(this.enteredEmail);
            });
            this.doSelect(this.startIndex, this.startIndex);
          }
        else if (navItem.key === 'clear_special') {
          this.$scope.$apply(()=>{
            this.enteredEmail = '';
            this.subStringOne = '';
            this.subStringTwo = '';
            this.startIndex = 0;
            //this.showEmailError =  this.textChange(this.enteredEmail);
          });
          this.doSelect(this.startIndex, this.startIndex);
        }
        else if (navItem.key === 'special_characters') {
          console.log('you clicked on the special characters');
          this.special_characters = true;
          console.log("this.special_characters is " + this.special_characters);
          this.removeFocusClass(navItem.key);
          this.currentItem = this.getKeyNavigation(navItem.next);
          this.addFocusClass(this.currentItem[0].key);
          this.$scope.$apply(()=>{
               this.enteredEmail = this.subStringOne + navItem.text + this.subStringTwo;
               this.showEmailError = false;
               //this.showEmailError = this.textChange(this.enteredEmail);
             });
        }
        else if (navItem.key === 'regular_characters') {
          console.log('you clicked on the regular characters');
          this.special_characters = false;
          console.log("this.special_characters is " + this.special_characters);
          this.removeFocusClass(navItem.key);
          this.currentItem = this.getKeyNavigation(navItem.next);
          this.addFocusClass(this.currentItem[0].key);
          this.$scope.$apply(()=>{
               this.enteredEmail = this.subStringOne + navItem.text + this.subStringTwo;
               this.showEmailError = false;
               //this.showEmailError = this.textChange(this.enteredEmail);
             });
        }
        else {
             this.$scope.$apply(()=>{
               this.enteredEmail = this.subStringOne + navItem.text + this.subStringTwo;
               this.showEmailError = false;
               //this.showEmailError = this.textChange(this.enteredEmail);
             });
             this.startIndex = this.startIndex + (navItem.text).length;
             this.subStringOne = (this.enteredEmail).substr(0,this.startIndex);
             this.subStringTwo = (this.enteredEmail).substr(this.startIndex);
             console.log(this.subStringOne +' String change ' + this.subStringTwo);
             this.doSelect(this.subStringOne.length, this.subStringOne.length);
          }
      }

      else if (event.code === 'ArrowRight' || event.keyIdentifier === 'Right' || event.keyCode === 39) {
        if (navItem.right) {
          this.removeFocusClass(navItem.key);
          this.currentItem = this.getKeyNavigation(navItem.right);
          this.addFocusClass(this.currentItem[0].key);
          this.eventPropFocus(event);
        }
        else {
          this.eventPropFocus(event);
        }
      }

      else if (event.code === 'ArrowLeft' || event.keyIdentifier === 'Left' || event.keyCode === 37) {
        if (navItem.left) {
          this.removeFocusClass(navItem.key);
          this.currentItem = this.getKeyNavigation(navItem.left);
          this.addFocusClass(this.currentItem[0].key);
          this.eventPropFocus(event);
        }
        else {
          this.eventPropFocus(event);
        }
      }

      else if (event.code === 'ArrowUp' || event.keyIdentifier === 'Up' || event.keyCode === 38) {
        if (navItem.up) {
          this.removeFocusClass(navItem.key);
          this.currentItem = this.getKeyNavigation(navItem.up);
          this.addFocusClass(this.currentItem[0].key);
          this.eventPropFocus(event);
        }
        else {
          this.eventPropFocus(event);
        }
      }

      else if (event.code === 'ArrowDown' || event.keyIdentifier === 'Down' || event.keyCode === 40) {
        if (navItem.down) {
          this.removeFocusClass(navItem.key);
          this.currentItem = this.getKeyNavigation(navItem.down);
          this.addFocusClass(this.currentItem[0].key);
          this.eventPropFocus(event);
        }
        else {
          this.eventPropFocus(event);
        }
      }
    };

  }

  addFocusClass(id){
    document.getElementById(id).classList.add('focusKey');
  }

  removeFocusClass(id){
    document.getElementById(id).classList.remove('focusKey');
  }

  focusElement(elementId){
    var ele = document.getElementById(elementId);
    if (ele) {
      ele.focus();
    } else {
      setTimeout(this.focusElement.bind(this,elementId));
    }
  }

  eventPropFocus(event){
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  doSelect(start,end) {
    var input = document.getElementById("userEmailId");
    input.focus();
    this.setSelectionRange(input, start, end);
  }

  setSelectionRange(input, start, end) {
      input.setSelectionRange(start, end);
  }

  getSplit(str, cnt){

  }
}

KeyboardController.$inject = ['storage','$state','$scope', '$rootScope', 'navigationManager','billingService', 'analyticsService'];

export default KeyboardController;



// WEBPACK FOOTER //
// ./client/app/components/keyboard/keyboard.controller.js